export default __webpack_public_path__ + "static/media/carbonoffset.6827e38d.svg";